import paramsHelper from '../helpers/params'

import { onlineModules, bookingTerminalPlanningTypes } from '../ui/params'

export default {
    data: () => ({onlineModules, bookingTerminalPlanningTypes}),
    methods: paramsHelper
}
